import { Spinner } from '../../icons'

export function LoadingScreen() {
  return (
    <div className='flex h-full w-full flex-1 flex-col items-center justify-center gap-4'>
      <Spinner className='animate-spin scale-150' />
    </div>
  )
}

export function LoadingRoute() {
  return (
    <div className='flex h-full w-full flex-col items-center justify-center gap-4'>
      <p>Loading</p>
      <Spinner />
    </div>
  )
}
